var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:_vm.badgeClasses},[_c('i',{staticClass:"fa mr-2",class:_vm.badgeIcon}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.badgeText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }